enum BatchloadExperimentReviewExpOptions {
  PLATE_ID = 1,
  SCREENNAME,
  TEMPERATURE,
  PLATE_BARCODE,
  DATE,
  EXP_NAME_TAG,
}

export default BatchloadExperimentReviewExpOptions;
